module.exports = __webpack_public_path__ + "media/v2/components/Blog/shared/img/play-326ce27131ac5eddb191973ba0e43479.svg";